import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalMC from './ModalMC';
import TitleMC from './TitleMC';
import IconMC from './IconMC';
import { Z_INDEX } from '../../constants/zIndex';

const ConfirmDeleteModalMC = ({
  visible,
  onClose,
  onConfirm,
  loading = false
}) => {
  const { t } = useTranslation('CalendarEventsScreenMC');

  const handleClose = () => {
    if (loading) return;
    onClose();
  };

  const handleConfirm = () => {
    if (loading) return;
    onConfirm();
  };

  return (
    <ModalMC
      visible={visible}
      onClose={handleClose}
      zIndex={Z_INDEX.calendarConfirmModal}
      containerClassName="tw-w-[95vw] tw-max-w-[520px]"
      className="!tw-p-0"
      hideCloseButton
      customHeader={(
        <div className="tw-flex tw-items-center tw-justify-between tw-px-6 tw-pt-6 tw-pb-2">
          <TitleMC
            text={t('confirm_delete.title', { defaultValue: 'Eliminar evento' })}
            variant="MODAL_TITLE"
            textClassName="tw-text-gray-950"
          />
          <button
            type="button"
            onClick={handleClose}
            className="tw-text-gray-400 hover:tw-text-gray-600 tw-p-0"
            disabled={loading}
            aria-label={t('actions.close', { defaultValue: 'Cerrar' })}
          >
            <IconMC name="close-outline" />
          </button>
        </div>
      )}
      footerClassName="tw-px-6 tw-pb-5 tw-pt-2"
      closeOnEsc={!loading}
      closeOnOverlayClick={!loading}
      buttons={[
        {
          label: t('actions.cancel', { defaultValue: 'Cancelar' }),
          onClick: handleClose,
          variant: 'SECONDARY',
          disabled: loading,
          className: 'tw-min-w-[120px] tw-h-[42px]'
        },
        {
          label: t('actions.delete', { defaultValue: 'Borrar' }),
          onClick: handleConfirm,
          variant: 'DANGER',
          disabled: loading,
          className: 'tw-min-w-[120px] tw-h-[42px]'
        }
      ]}
    >
      <div className="tw-px-6 tw-pt-1 tw-pb-6">
        <p className="tw-mb-0 tw-text-sm tw-leading-6 tw-text-gray-600">
          {t('confirm_delete.description', {
            defaultValue: 'Esta acción no es reversible. ¿Quieres eliminar el evento?'
          })}
        </p>
      </div>
    </ModalMC>
  );
};

export default ConfirmDeleteModalMC;
